import styled, { css } from "styled-components";
import { lighten } from "polished";
import { experienceEasterPath } from "../../../../../paths";
import { IStyleProps } from "./interfaces";

export const recBtnDimension = 100;
export const recBtnDimensionLow = 80;

export const PushButton = styled.button<IStyleProps>`
    position: absolute;
    bottom: ${p => (p.isLow ? 200 : 32)}px;
    left: ${p => (1280 - (p.isLow ? recBtnDimensionLow : recBtnDimension)) / 2}px;
    width: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension)}px;
    height: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension)}px;
    border-radius: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension) / 2}px;
    background-color: ${p => p.theme.c.record};
    border: none;
    box-shadow: 0 0 0 2px black inset;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;
    transition: background-color 300ms;

    &:disabled {
        cursor: default;
        background-color: ${p => lighten(0.2, p.theme.c.record)};
        pointer-events: none;
    }

    div {
        background-color: transparent;
        border: 0;
    }

    svg {
        width: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension) * 0.8}px;
        height: ${p => (p.isLow ? recBtnDimensionLow : recBtnDimension) * 0.8}px;
        .color-1-fill,
        .color-2-fill {
            fill: ${p => p.theme.c.snowOnActive};
        }
    }

    transition: transform 70ms, box-shadow 70ms;

    :active {
        transform: scale(0.93);
        box-shadow: 0 0 0 2px black inset,
            0 0 ${p => (p.isLow ? 8 : 12)}px 0 ${p => p.theme.c.blackShadow4};
    }

    ${p => p.isEaster && css`
        background-color: transparent;
        background-image: url("${experienceEasterPath}/record-button.svg");
        background-size: 100% 100%;
        box-shadow: none;
        width: 200px;
        padding-right: 3px !important;
        height: 200px;
        left: ${(1280 - 200) / 2}px;
        bottom: -10px;

        :active {
            box-shadow: none;
        }
        &:disabled {
            background-color: transparent;
            opacity: 0.7;
        }
    `}
`;
